export function resolveGoldVariant(variants, selectedOptions, position, value) {
  return variants.find(variant => variant.options.every((option,index) =>
    option === (index === position-1 ? value : selectedOptions[index])
  ));
}
export function goldColour(value) {
  const lower = value.toLowerCase().trim();
  return ['yellow','white','rose'].find(colour => lower === colour || lower === colour+' gold') || 'neutral';
}
export function purityLabel(value) {
  return value.toUpperCase().replaceAll(' ','').replace(/KT?/g,'KT');
}
if (typeof customElements !== 'undefined' && !customElements.get('glora-product-options')) {
  customElements.define('glora-product-options', class extends HTMLElement {
    connectedCallback() {
      const root = this.closest('[id^="shopify-section-"]');
      const picker = root?.querySelector('.product-info variant-picker');
      if (!picker) return;
      this.controller?.abort();
      this.controller = new AbortController();
      this.variants = JSON.parse(this.querySelector('[data-glora-variants]').textContent);
      this.positions = [Number(this.dataset.metalPosition), Number(this.dataset.colourPosition)].filter(Boolean);
      this.valueOptions = JSON.parse(this.querySelector('[data-glora-option-values]').textContent);
      const hideNativeGold = () => {
        const currentPicker = root.querySelector('.product-info variant-picker');
        const groups = currentPicker?.querySelectorAll('fieldset.variant-picker__option');
        if (!groups?.length || this.positions.some(position => !groups[position - 1])) return;
        this.positions.forEach(position => { if (!groups[position - 1].hidden) groups[position - 1].hidden = true; });
      };
      hideNativeGold();
      this.updateOptions(picker.selectedVariant || this.variants.find(v => String(v.id) === this.dataset.selectedId));
      this.root = root;
      if (picker.getAttribute('context') === 'main_product' && this.dataset.productId) {
        this.addEventListener('click', event => this.selectGold(event), {signal:this.controller.signal});
        const restore = () => { this.restoreFrame = requestAnimationFrame(() => { if (this.isConnected) this.restoreProperties(); }); };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', restore, {once:true, signal:this.controller.signal});
        else restore();
      }
      this.observer?.disconnect();
      this.observer = new MutationObserver(hideNativeGold);
      this.observer.observe(root, {childList:true, subtree:true});
      root.addEventListener('variant:change', event => {
        const selected = event.detail?.variant;
        if (selected?.options) this.updateOptions(selected);
      }, {capture:true, signal:this.controller.signal});
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); cancelAnimationFrame(this.restoreFrame); }
    propertyForm() {
      const id = this.root?.querySelector('.product-info variant-picker')?.getAttribute('form-id');
      const form = id && document.getElementById(id);
      return form?.tagName === 'FORM' && this.root.contains(form) ? form : null;
    }
    propertyFields() {
      // Only predefined purchase choices travel. Contact details and free text never enter storage.
      return [...(this.propertyForm()?.elements || [])].filter(field => {
        const match = /^properties\[([^\]]+)\]$/.exec(field.name || '');
        return match && !field.disabled && !match[1].startsWith('_') &&
          !/email|phone|address|recipient|message|note|engraving|personal|(?:^|[ _-])name(?:$|[ _-])/i.test(match[1]) &&
          field.matches('select,input[type="radio"],input[type="checkbox"]');
      });
    }
    selectGold(event) {
      const link = event.target.closest('a.glora-gold-option');
      if (!link || !this.contains(link) || event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      const picker = this.root?.querySelector('.product-info variant-picker');
      const target = this.variants.find(item => String(item.id) === new URL(link.href).searchParams.get('variant'));
      if (!target || !target.available || typeof picker?.selectCombination !== 'function') return;
      const options = JSON.parse(this.querySelector('[data-glora-option-values]').textContent);
      const values = target.options.map((name, index) => options[index]?.find(value => value.name === name)?.id);
      if (values.some(value => !value)) return;
      event.preventDefault();
      if (String(picker.selectedVariant?.id) === String(target.id)) return;
      this.setAttribute('aria-busy', 'true');
      this.querySelector('.gp-gold-status').textContent = this.dataset.loading;
      picker.selectCombination({optionValues: values.map(String), productChange: false}).finally(() => {
        if (this.isConnected) {this.removeAttribute('aria-busy');this.querySelector('.gp-gold-status').textContent = '';}
      });
    }
    rememberProperties(event) {
      const link = event.target.closest('a.glora-gold-option');
      if (!link || !this.contains(link) || event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || (link.target && link.target !== '_self')) return;
      const key = 'glora:gold-property-handoff';
      try {
        const target = new URL(link.href, location.origin), product = new URL(this.dataset.productUrl, location.origin);
        const variant = target.searchParams.get('variant');
        if (target.origin !== location.origin || target.pathname !== product.pathname || !this.variants.some(item => String(item.id) === variant)) return;
        const fields = this.propertyFields().slice(0,32).flatMap(field => {
          if (field.tagName === 'SELECT') {
            const values = [...field.selectedOptions].filter(option => option.value && !option.disabled && !option.closest('optgroup')?.disabled).map(option => option.value).filter(value => value.length <= 200);
            return values.length ? [{name:field.name, type:'select', values}] : [];
          }
          if (field.type === 'radio' && !field.checked) return [];
          return field.value.length <= 200 ? [{name:field.name,type:field.type,value:field.value,checked:field.checked}] : [];
        });
        sessionStorage.removeItem(key);
        if (fields.length) sessionStorage.setItem(key, JSON.stringify({at:Date.now(),product:this.dataset.productId,path:target.pathname,variant,fields}));
      } catch (_) { /* Storage can be unavailable; native navigation and validation remain usable. */ }
    }
    restoreProperties() {
      const key = 'glora:gold-property-handoff';
      let saved;
      try { saved = JSON.parse(sessionStorage.getItem(key) || 'null'); sessionStorage.removeItem(key); } catch (_) { return; }
      if (!saved || saved.product !== this.dataset.productId || saved.path !== location.pathname || saved.variant !== new URL(location.href).searchParams.get('variant') || saved.variant !== this.dataset.selectedId || !Number.isFinite(saved.at) || Date.now() - saved.at < 0 || Date.now() - saved.at > 120000 || !Array.isArray(saved.fields)) return;
      const fields = this.propertyFields();
      saved.fields.slice(0,32).forEach(value => {
        if (!value || typeof value.name !== 'string') return;
        fields.filter(field => field.name === value.name).forEach(field => {
          if (value.type === 'select' && field.tagName === 'SELECT' && Array.isArray(value.values)) {
            const allowed = [...field.options].filter(option => !option.disabled && !option.closest('optgroup')?.disabled && value.values.includes(option.value));
            if (!allowed.length || (!field.multiple && allowed.length !== 1)) return;
            [...field.options].forEach(option => { option.selected = allowed.includes(option); });
          } else if (field.type === value.type && ['radio','checkbox'].includes(value.type) && field.value === value.value && typeof value.checked === 'boolean') {
            field.checked = value.checked;
          } else return;
          field.dispatchEvent(new Event('input',{bubbles:true}));
          field.dispatchEvent(new Event('change',{bubbles:true}));
        });
      });
    }
    updateOptions(selected) {
      if (!selected?.options) return;
      const activeId = this.contains(document.activeElement) ? document.activeElement.id : '';
      this.dataset.selectedId = selected.id;
      const axes = this.querySelector('.gp-gold-axes');
      const groups = [];
      const definitions = [
        {position:Number(this.dataset.colourPosition), name:'colour', label:this.dataset.colourLabel},
        {position:Number(this.dataset.metalPosition), name:'purity', label:this.dataset.purityLabel}
      ];
      definitions.filter(axis => axis.position > 0).forEach(axis => {
        const fieldset = document.createElement('fieldset');
        fieldset.className = 'gp-gold-axis'; fieldset.dataset.gpAxis = axis.name;
        const legend = document.createElement('legend'); legend.textContent = axis.label;
        const choices = document.createElement('div'); choices.className = 'gp-gold-choices';
        const values = [...(this.valueOptions[axis.position-1] || [])].sort((a,b) => {
          if(axis.name === 'purity') return (parseInt(a.name)||999)-(parseInt(b.name)||999);
          const rank = value => ['yellow','white','rose'].findIndex(c => value.toLowerCase().includes(c));
          return rank(a.name)-rank(b.name);
        });
        values.forEach(value => {
          const target = resolveGoldVariant(this.variants, selected.options, axis.position, value.name);
          const available = target?.available === true;
          const choice = document.createElement(available ? 'a' : 'button');
          choice.className = 'glora-gold-option';
          choice.id = 'Gold-'+this.dataset.key+'-'+axis.position+'-'+value.id;
          choice.dataset.gpPosition = axis.position; choice.dataset.gpValue = value.name;
          if (available) choice.href = this.dataset.productUrl+'?variant='+target.id;
          else {choice.type='button';choice.disabled=true;choice.classList.add('is-unavailable');}
          if (selected.options[axis.position-1] === value.name) {
            choice.classList.add('is-selected');
            if(available) choice.setAttribute('aria-current','true');
          }
          let label = value.name;
          if (axis.name === 'colour') {
            const colour = goldColour(value.name);
            label = colour === 'neutral' ? value.name : this.dataset[colour];
            const swatch = document.createElement('span');
            swatch.className = 'glora-gold-option__colour glora-gold-option__colour--'+colour;
            swatch.setAttribute('aria-hidden','true'); choice.append(swatch);
          } else label = purityLabel(value.name);
          const text = document.createElement('span'); text.textContent = label; choice.append(text);
          if (!available) {
            const hint = document.createElement('small');
            hint.textContent = target ? this.dataset.soldOut : this.dataset.unavailable;
            choice.append(hint);
          }
          choices.append(choice);
        });
        fieldset.append(legend,choices); groups.push(fieldset);
      });
      axes.replaceChildren(...groups);
      if(activeId) this.querySelectorAll('[id]').forEach(node => {if(node.id===activeId)node.focus({preventScroll:true});});
    }
  });
}
